import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { DateInputSize, DateInputRounded, DateInputFillMode } from '@progress/kendo-angular-dateinputs';

@Component({
  selector: 'app-choose-dictionary',
  templateUrl: './choose-dictionary.component.html',
  styleUrls: ['./choose-dictionary.component.scss'],
  standalone: false,
})
export class ChooseDictionaryComponent implements OnInit {
  dictionariesDatasource: app.models.DictionaryDataModel[];
  selectedDictionary: app.models.DictionaryDataModel;

  isDictionarySelected: boolean = false;

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';

  constructor(
    private _dictionaryAPIServivce: DictionaryAPIService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this._dictionaryAPIServivce.getDictionaries().subscribe(result => {
      this.dictionariesDatasource = result;
    });
  }

  redirectChooseLanguage() {
    this._router.navigate(['languages', this.selectedDictionary]);
  }

  handlerDictionarySelected(event: any) {
    this.isDictionarySelected = isNotEmpty(event);
  }
}
